import CRXDashboard from './CRXDashboard';

export default CRXDashboard;
